/* eslint-disable jsx-a11y/alt-text */

import clearIcon from "../images/clear.svg";
import styles from "../styles/components/PromptGenerate.module.css";
import common from "../styles/Common.module.css";
const PromptComposeItem = ({ character, selected, onRemove, onSelect}) => {

	return (
		<div className={selected ? styles.promptGenerateCharacterSelected : styles.promptGenerateCharacter}
		onClick={()=>onSelect(character)}>
			<img src={character?.thumbnail}/>
			<button className={common.closeButton} onClick={()=>onRemove(character)}>
				<img src={clearIcon} />
			</button>
		</div>
		
	);
};

export default PromptComposeItem;
